import { setDomains } from '~~/helpers/domains';

/**
 * Hands the Vue app its own copy of the domain map.
 *
 * On the client `runtimeConfig.public.domains` arrives with the payload and this plugin is the
 * earliest point where a Nuxt instance exists to read it, so every later `getDomainByCountry()` —
 * including the ones `useHead` runs outside setup — resolves from plain data instead of a
 * composable. On the server the Nitro plugin has already filled the same snapshot; re-setting it
 * per request costs nothing and keeps the Vue SSR bundle independent of module-graph boundaries.
 *
 * `enforce: 'pre'` so the snapshot is in place before any other plugin resolves a domain.
 */
export default defineNuxtPlugin({
  name: 'domains',
  enforce: 'pre',
  setup () {

    setDomains(useRuntimeConfig().public.domains);

  },
});
